// =================
// Carte interactive
// =================

// Au hover sur les différentes villes (SVG)
const citiesMap = document.querySelectorAll('.map__svg-wrapper svg a'); // on sélectionne dans le DOM toutes les villes contenues dans le SVG

citiesMap.forEach(city => { // on itère sur le tableau citiesMap
    city.addEventListener('mouseover', (event) => { // à chaque SVG de ville survolé
        let currentCityClass = event.currentTarget.getAttribute('class'); // on récupère la class de la ville survolée
        document.querySelector('.map__list a.' + currentCityClass).classList.add('map__item__hover'); // on ajoute la classe ville_hover au nom de ville concerné pour avoir la couleur renseignée en CSS
    });

    city.addEventListener('mouseout', (event) => { // si on ne survole plus la ville en question
        let currentCityClass = event.currentTarget.getAttribute('class');
        document.querySelector('.map__list a.' + currentCityClass).classList.remove('map__item__hover'); // on remove la class
    });
});


// Au hover sur les différentes villes (Text)
const citiesNames = document.querySelectorAll('.map__list a'); // on sélectionne tous les noms des villes

citiesNames.forEach(city => { // on itère sur le tableau citiesNames
    city.addEventListener('mouseover', (event) => { // à chaque nom de ville survolé
        let currentCityClass = event.currentTarget.getAttribute('class'); // on récupère la class de la ville survolée
        document.querySelector('.map svg a.' + currentCityClass + ' path').classList.add('map__hover'); // on ajoute la classe map_hover au path concerné pour avoir la couleur renseignée en CSS
    });

    city.addEventListener('mouseout', (event) => { // si on ne survole plus le nom de ville en question
        let currentCityClass = event.currentTarget.getAttribute('class');
        document.querySelector('.map svg a.' + currentCityClass + ' path').classList.remove('map__hover'); // on remove la class
    });
});


//Select cities
let dropdown = document.querySelector(".map__dropdown--select");

if (dropdown) {
    dropdown.addEventListener('change', () => {
        var selectedCity = dropdown.value;
    
        if ( selectedCity != '#' ) {
            window.location.href = selectedCity;
        }
    });
}